import { TAddress, TPerson } from 'app/modules/goAML/models';

export enum SettingsActionTypes {
  EDIT_GO_AML_TEMPLATES = '@@settings/EDIT_GO_AML_TEMPLATES',
  EDIT_GO_AML_TEMPLATES_SUCCESS = '@@settings/EDIT_GO_AML_TEMPLATES_SUCCESS',
  RETRIEVE_GO_AML_TEMPLATES = '@@settings/RETRIEVE_GO_AML_TEMPLATES',
  RETRIEVE_GO_AML_TEMPLATES_SUCCESS = '@@settings/RETRIEVE_GO_AML_TEMPLATES_SUCCESS',
}

export interface RetrieveGoAMLTemplatesResult {
  content: RetrieveGoAMLTemplatesContent;
  created_at: string;
  id: number;
  org_id: number;
  tag_id?: number;
  template_type?: string;
  updated_at?: string;
}

export interface RetrieveGoAMLTemplatesContent {
  report?: RetrieveGoAMLTemplatesReport;
}

export interface RetrieveGoAMLTemplatesReport {
  rentity_branch?: string;
  rentity_id?: string;
  currency_code_local?: string;
  entity_reference?: string;
  location?: TAddress;
  reporting_person?: TPerson;
}

export interface EditGoAMLFormValues {
  content: RetrieveGoAMLTemplatesContent;
}
